/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ObjectSchema implements Wars.Domain.Model.ObjectSchema {
        constructor() {

        }

        myDataSource: Wars.Domain.Model.DataSource;
        dataSource_id: string;
        formUniqueId: string;
        schemaProperty_id: string;
        name: string;
        properties: warsApp.models.SchemaProperty[];
        parentProperty: Wars.Domain.Model.SchemaProperty;
        uniqueIdentifier: string;
        isList: boolean;
        mySystemLevel: Wars.Domain.Model.SystemLevel;
        id: string;
        lastUpdateUserName: string;
        entityAspect: breeze.EntityAspect;
        entityType: breeze.EntityType;
        clonedFromId: string;
    }
}